<style scoped>
.modal {
  z-index: 500;
}
a.print {
  position: absolute;
  right: 2em;
  top: 2em;
  display: flex;
  align-items: center;
}
.page {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}
.signature {
  height: 60px;
}
</style>

<template>
  <div
    v-if="localActive"
    id="modal-id"
    class="modal modal-lg active print"
  >
    <a
      @click="close"
      aria-label="Close"
      class="modal-overlay"
    />

    <div
      v-if="loaded"
      class="modal-container"
    >

      <div
        v-for="copy of getCopies"
        :key="copy"
        :class="copy === 1 ? '' : 'd-hide'"
        class="page"
      >
        <h1
          class="close-button z-50"
          @click="close"
        >
          <i class="icon icon-cross" />
        </h1>

        <header class="modal-header">
          <a
            class="print btn btn-default btn-sm"
            @click="print"
          >
            <dr-icon
              style="width: 20px"
              name="imprimir"
              fill="white"
            />
            &emsp;Imprimir
          </a>
        </header>

        <div
          id="medical-document"
          class="modal-body"
        >
          <component
            :is="type"
            :formData="formData"
            :patient="getPatient"
            :doctor="doctor"
            :active="active"
            @loaded="loaded = $event"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import prescription from '@/components/templates/print/medicalPrescription'
import prescriptionSpecial from '@/components/templates/print/medicalPrescriptionSpecial'
import sicknote from '@/components/templates/print/sickNote'
import exam from '@/components/templates/print/exam'
import receipt from '@/components/templates/print/receipt'

export default {
  props: ['formData', 'active', 'patient', 'type', 'copies'],

  components: {
    prescription,
    prescriptionSpecial,
    sicknote,
    exam,
    receipt
  },
  data () {
    return {
      loaded: false,
      localActive: false,
      doctor: null,
      signature: null,
      address: null,
      cid: null
    }
  },
  computed: {
    getCopies () {
      return this.copies || 1
    },
    getPatient () {
      return this.patient || this.active.agenda.patient || null
    },
    medicalSpecialties () {
      return this.doctor['medical_specialties'].map(n => n.name).join(', ')
    },

    medicalAssinatureURL () {
      return `${process.env.ROOT_API}/s3/file/doctor/${this.active.agenda.doctor.id}/signature_picture`
    }
  },
  mounted () {
    this.loaded = false
    this.fn_SHOW_PROGRESS()
    this.localActive = true
    const body = document.getElementsByTagName('body')[0]
    body.style.overflow = 'hidden'
    let url = this.fn_IS_DOCTOR() ? '/doctor' : `/secretary/doctor/${this.$route.params.doctorId}`
    this.$http.get(url, this.$store.getters.getAuthHeader).then(
      (res) => {
        this.$http.get(`${url}/signature_picture`, this.$store.getters.getAuthHeader).then(
          (res) => {
            this.signature = res.data
          }
        )
        if (this.active.agenda.doctor_office.address) {
          this.address = this.active.agenda.doctor_office.address
        } else {
          this.$http.get(`${url}/doctor_office/${this.active.agenda.doctor_office.id}`, this.$store.getters.getAuthHeader).then(
            (res) => {
              this.address = res.data.address
            }
          )
        }
        this.doctor = res.data
        this.loaded = true
        this.fn_HIDE_PROGRESS()
      }
    ).catch(
      (err) => {
        console.log(err)
      }
    )
  },
  destroyed () {
    const body = document.getElementsByTagName('body')[0]
    body.style.overflow = 'initial'
  },
  methods: {
    close () {
      this.localActive = false
      this.$emit('cancel', true)
    },
    print () {
      this.$htmlToPaper('medical-document', () => {
        this.$emit('cancel', true)
      })
    }
  }
}
</script>
